module.exports = __webpack_public_path__ + "html/icon-text-list_0c852ae1f083070b7e9af084430c35f2.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/landing-template/components/icon-text-list.html
// module id = MVO1
// module chunks = 70